/*
 * 封装自定义指令v-sliden-in  元素平滑上升
 * Vue2版本！钩子使用 inserted / unbind，不是 mounted/unmounted
 */
const DISTANCE = 100; //平滑上升距离
const DURATION = 800; //动画播放总时长
const map = new WeakMap();
const ob = new IntersectionObserver(entries => {
	for(const entry of entries) {
		if (entry.isIntersecting) {
			// 出现在视口
			const animation = map.get(entry.target);
			animation && animation.play();
			ob.unobserve(entry.target)
		}
	}
});
function isBelowViewport(el) {
	const rect = el.getBoundingClientRect();
	// 元素是否在视口下方
	return rect.top - window.innerHeight > 0;
}

export default {
	// ✅Vue2 使用 inserted，元素插入DOM树后触发（代替Vue3的mounted）
	inserted(el) {
		console.log('v‑sliden‑in 执行', el)
		// ⚠️首屏内元素直接return，不会做动画！
		if (!isBelowViewport(el)){
			console.log('元素在首屏可视区，跳过动画');
			return;
		}
		const animation = el.animate([{
			transform: `translateY(${DISTANCE}px)`,
			opacity: 0.5
		}, {
			transform: `translateY(0)`,
			opacity: 1
		}], {
			duration: DURATION,
			easing: 'ease-out',
			fill: 'forwards'
		});
		animation.pause(); //暂停动画
		map.set(el,animation)
		ob.observe(el);
	},
	// ✅Vue2 unbind，代替 unmounted
	unbind(el) {
		ob.unobserve(el);
	}
}
